import React, { useRef } from "react";
import { toast } from "react-toastify";

import config from "../../../config.js"; // Import the config file

const API_BASE_URL = config.API_BASE_URL;

const IntegrationDetails = ({ details, status }) => {
  const urlRef = useRef(null);

  const handleCopyToClipboard = () => {
    if (urlRef.current) {
      const url = urlRef.current.textContent;
      navigator.clipboard.writeText(url)
        .then(() => {
          toast.success('URL copied to clipboard!');
        })
        .catch((err) => {
          toast.error('Failed to copy URL to clipboard.');
          console.error('Failed to copy URL to clipboard:', err);
        });
    }
  };

  const getApiUrl = (integrationId) => {
    return `${API_BASE_URL}/api/integrations/execute/${integrationId}/`;
    // return `https://astronode-h2a5fsfxc3fkapef.centralus-01.azurewebsites.net/integrations/integrate/${integrationId}/trigger`;
  }

  if (details === null) return (
    <div>Loading</div>)

  return (
    <div className="mx-auto mb-2 mt-0 w-[96%] rounded-2xl border border-blue-400 bg-white px-6 py-4 shadow-sm sm:px-7 sm:py-5">
      {/* <div className="text-sm">
        <div className="text-white">
          <div className="text-lg font-medium">Integration Details</div>
        </div>
      </div> */}

      <div className="mt-0 flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
        <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Integration Name:</div>
        <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
          {details.name}
        </div>
      </div>

      <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
        <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Description:</div>
        <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
          {details.description}
        </div>
      </div>

      <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
        <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">URL:</div>
        <div className="flex w-full sm:w-3/4 lg:w-5/6 items-center justify-between rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium overflow-hidden">
          <div ref={urlRef} className="truncate mr-4 italic text-blue-600 font-mono text-[11px] sm:text-[14px]">
            {getApiUrl(details.integration_id)}
          </div>
          <button
            onClick={handleCopyToClipboard}
            className="flex-shrink-0 rounded-lg bg-blue-600 px-3 sm:px-4 py-1 sm:py-0.5 text-[10px] font-black text-white transition-all duration-200 hover:bg-blue-700 hover:shadow-md active:scale-95 uppercase whitespace-nowrap"
          >
            Copy URL
          </button>
        </div>
      </div>

      <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
        <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Trigger Type:</div>
        <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
          {details.triggerDetails.triggerType}
        </div>
      </div>

      {details.trigger_connection_detail && (
        <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
          <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Trigger Account:</div>
          <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
            {details.trigger_connection_detail.display_name}
          </div>
        </div>
      )}

      {details.source_connection_detail && (
        <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
          <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Source Account:</div>
          <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
            {details.source_connection_detail.display_name}
          </div>
        </div>
      )}

      {details.destination_connection_detail && (
        <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
          <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Destination Account:</div>
          <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
            {details.destination_connection_detail.display_name}
          </div>
        </div>
      )}

      {(details.triggerDetails.triggerType === "Http Trigger" || details.triggerDetails.triggerType === "Webhook Trigger") &&
        <>
          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Http Method:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium">
              {details.triggerDetails.triggerHttpMethod}
            </div>
          </div>

          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Source Type:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium whitespace-pre-wrap break-words">
              {details.sourceDetails.sourceType}
            </div>
          </div>

          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Source Url:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium whitespace-pre-wrap break-words">
              {details.sourceDetails.restAPISourceUrl}
            </div>
          </div>

          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Destination Type:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium whitespace-pre-wrap break-words">
              {details.destinationDetails.destinationType}
            </div>
          </div>

          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 pl-1 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Destination Url:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium whitespace-pre-wrap break-words">
              {details.destinationDetails.restAPIDestinationUrl}
            </div>
          </div>
        </>
      }

      {details.triggerDetails.triggerType === "Timer Trigger" &&
        <>
          <div className="flex flex-col gap-2 py-1 sm:flex-row sm:items-center sm:gap-4">
            <div className="w-full sm:w-1/4 lg:w-1/6 sm:pl-4 text-[#424242] font-bold text-[10px] sm:text-xs uppercase tracking-wider">Cron Expression:</div>
            <div className="w-full sm:w-3/4 lg:w-5/6 rounded-xl bg-white border border-blue-400 p-3 sm:p-2.5 text-[14px] text-gray-900 font-medium whitespace-pre-wrap break-words">
              {details.triggerDetails.triggerCronExpression}
            </div>
          </div>
        </>
      }

    </div>
  );
};

export default IntegrationDetails;
